import React from 'react';
import PropTypes from 'prop-types';
import Box from 'reusecore/src/elements/Box';
import Text from 'reusecore/src/elements/Text';
import Image from 'reusecore/src/elements/Image';
import Heading from 'reusecore/src/elements/Heading';
import FeatureBlock from 'common/src/components/FeatureBlock';
import Container from 'common/src/components/UI/Container';
import BannerWrapper, {
  BannerObject,
} from './bannerSection.style';

import TechImage from 'common/src/assets/image/saas/banner/how-it-works3.png';

const TechSection = ({
  row,
  col,
  title,
  description,
}) => {
  return (
    <BannerWrapper id="tech_section">
      <Container>
        <Box className="row" {...row}>
          <Box className="col" {...col}>
            <FeatureBlock
              title={
                <Heading
                  content="How it works"
                  {...title}
                />
              }
              description={
                <div>
                  <Text
                    content="Your data stays securely with your Atlassian instance. The Europa Service creates servers on-demand to run your notebooks."
                    {...description}
                  />
                  <Text
                    content="This means that as well as publishing notebooks for other users to read and comment on, you can create and edit notebooks without leaving the Atlassian environment."
                    {...description}
                  />
                  <Text
                    content="Your environment to collaborate, explore, analyse and model is one; which makes teams more productive and easier to combine team processes with data science and data engineering tasks."
                    {...description}
                  />
                </div>
              }
            />
          </Box>
        </Box>
      </Container>
      <BannerObject>
        <div className="objectWrapper">
          <Image src={TechImage} alt="How it works" />
        </div>
      </BannerObject>
    </BannerWrapper>
  );
};

TechSection.propTypes = {
  title: PropTypes.object,
  btnStyle: PropTypes.object,
  description: PropTypes.object,
  contentStyle: PropTypes.object,
  discountText: PropTypes.object,
  discountAmount: PropTypes.object,
  outlineBtnStyle: PropTypes.object,
};

TechSection.defaultProps = {
  row: {
    flexBox: true,
    flexWrap: 'wrap',
    ml: '-15px',
    mr: '-15px',
    alignItems: 'center',
  },
  col: {
    pr: '15px',
    pl: '15px',
    width: [1, '70%', '50%', '45%'],
  },
  title: {
    fontSize: ['22px', '34px', '30px', '40px'],
    fontWeight: '700',
    color: '#0f2137',
    letterSpacing: '-0.025em',
    mb: ['20px', '25px'],
    lineHeight: '1.5',
  },
  description: {
    fontSize: '16px',
    color: '#343d48cc',
    lineHeight: '1.75',
    mb: '0',
  },
};

export default TechSection;
